import { useTable } from '@/modules/drivers/context/TableContext'
import { TableHeader } from '@/modules/drivers/shared/tableItems/TableHeader'
import React from 'react'
import AttestationRowItem, { AttestationRow } from './AttestationRowItem'
import { useSortableData } from '@/modules/drivers/hooks/useSortTable'
import { getAttestationsColumns } from '@/modules/drivers/constants/tables'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const AttestationTable = ({
  attestations,
}: {
  attestations: AttestationRow[]
}) => {
  const { t, tSafe } = useLocalize()
  const columns = getAttestationsColumns(t, tSafe)
  const { isSelectedAny, toggleAll, toggleId, selectedGroup, setAllIds } =
    useTable()
  const { sortedData, sortConfig, handleHeaderClick } =
    useSortableData<AttestationRow>({
      data: attestations,
      tableColumns: columns,
    })

  React.useEffect(() => {
    setAllIds(attestations.map((attestation) => ({ id: Number(attestation.id) })))
  }, [attestations, setAllIds])

  return (
    <div className="tw-w-full">

      <table className="tw-w-full tw-min-w-full tw-table-auto tw-border-collapse">
        <TableHeader
          columns={columns}
          fontSize="md"
          isSelectedAny={isSelectedAny}
          sortConfig={sortConfig}
          sticky
          bolder
          rounded={false}
          toggleAll={toggleAll}
          onHeaderClick={handleHeaderClick}
        />
        <tbody className="tw-relative">
          {sortedData &&
            sortedData.map((attestation) => (
              <AttestationRowItem
                key={attestation.id}
                selectedIds={selectedGroup?.ids ?? []}
                attestation={attestation}
                toggleId={toggleId}
              />
            ))}
        </tbody>
      </table>
    </div>
  )
}

export default AttestationTable
